const key = (id) => `vzpominkovnik.profile.${id}.session`;

export const profileHeaders = (id) => {
  const globalToken = localStorage.getItem('vzpominkovnikAdminToken');
  const token = sessionStorage.getItem(key(id));
  return { ...(globalToken ? { 'x-admin-token': globalToken } : {}), ...(token ? { 'x-profile-token': token } : {}) };
};
export const hasProfileSession = (id) => Boolean(sessionStorage.getItem(key(id)) || localStorage.getItem('vzpominkovnikAdminToken'));
export const saveProfileSession = (id, token) => sessionStorage.setItem(key(id), token);
export const clearProfileSession = (id) => sessionStorage.removeItem(key(id));
